import type {
    PaymentOrderDetailData,
    PaymentOrderListData,
    PaymentOrderListParams,
} from './interface';
import {request} from '@/services';

const ORDER_ENDPOINTS = {
    /** 当前会员订阅信息 */
    ORDER_DETAIL: 'proxy-aicomic/payment/order/detail',
    /** 订单记录列表 */
    ORDER_LIST: 'proxy-aicomic/payment/order/list',
} as const;

/** 获取当前用户的订阅详情 */
export const getPaymentOrderDetail = () =>
    request.get<PaymentOrderDetailData>(ORDER_ENDPOINTS.ORDER_DETAIL);

/** 获取订单记录列表 */
export const getPaymentOrderList = (params: PaymentOrderListParams) =>
    request.get<PaymentOrderListData>(ORDER_ENDPOINTS.ORDER_LIST, {params});
